import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["isOpen", "useDrawer", "side"];
import React, { memo, Fragment } from 'react';
import { Drawer } from 'hoi-poi-ui';
import ContentWrapper from "./ContentWrapper";
import { FiltersContext, FiltersProvider, FiltersConsumer } from "./Context";
import { operators, fieldOperators } from "./operators";
const Filters = /*#__PURE__*/memo(_ref => {
  let {
      isOpen,
      useDrawer = true,
      side = 'right'
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(Fragment, null, useDrawer && /*#__PURE__*/React.createElement(Drawer, {
    side: side,
    isOpen: isOpen,
    width: "400px",
    shouldCloseOnOverlayClick: true,
    hideOverlay: true
  }, /*#__PURE__*/React.createElement(ContentWrapper, _extends({
    isOpen: isOpen
  }, props))), !useDrawer && /*#__PURE__*/React.createElement(ContentWrapper, props));
});
export default Filters;
export { FiltersContext, FiltersProvider, FiltersConsumer, operators, fieldOperators };